export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.yearSelectChange();
    }

    yearSelectChange() {
        const sel = document.querySelector(".news__years select");
        sel.addEventListener("change", (event) => {
            if (event.target.value) {
                let url = new URL(document.location);
                let params = url.searchParams;
                params.set("y", event.target.value);
                if (params.has("page")) params.delete("page");
                url.search = params.toString();
                location.href = url.toString();
            }
        });
    }
}
